import React, { ReactNode, createContext, useContext, useState } from "react";

interface AppSettingsContextType {
  doInitialRedirect: boolean;
  setDoInitialRedirect: (value: boolean) => void;
}

const AppSettingsContext = createContext<AppSettingsContextType | undefined>(
  undefined,
);

interface AppSettingsProviderProps {
  children: ReactNode;
}

export const AppSettingsProvider: React.FC<AppSettingsProviderProps> = ({
  children,
}) => {
  const [doInitialRedirect, setDoInitialRedirect] = useState<boolean>(true);

  return (
    <AppSettingsContext.Provider
      value={{
        doInitialRedirect,
        setDoInitialRedirect,
      }}
    >
      {children}
    </AppSettingsContext.Provider>
  );
};

export const useAppSettings = (): AppSettingsContextType => {
  const context = useContext(AppSettingsContext);
  if (!context) {
    throw new Error("useAppSettings must be used within a AppSettingsProvider");
  }
  return context;
};
